import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
	plugins: [createPersistedState()],
	state: {
		parameters: "",
		panel: "",
		segment: "",
		datecompare: { gte: "", lte: "" },
		pageName: "",
		admin: 1,
		userId: 0,
		//mastertagTop100: "",
		expiredFilters: "",
	},
	getters: {
		panel: (state) => {
			return state.panel;
		},
		segment: (state) => {
			return state.segment;
		},
		datecompare: (state) => {
			return state.datecompare;
		},
		parameters: (state) => {
			return state.parameters ? JSON.parse(state.parameters) : {};
		},
		pageName: (state) => {
			return state.pageName;
		},
		admin: (state) => {
			return state.admin;
		},
		/*mastertagTop100: (state) => {
        	return state.mastertagTop100;
        },*/
		userId: (state) => {
			return state.userId;
		},
		expiredFilters: (state) => {
			return state.expiredFilters;
		},
	},
	mutations: {
		addToParameters(state, payload) {
			if (state.parameters) {
				let storeParameters = JSON.parse(state.parameters);
				storeParameters[payload.key] = payload.value;
				state.parameters = JSON.stringify(storeParameters);
			}
		},
		removeFromParameters(state, key) {
			if (state.parameters) {
				let storeParameters = JSON.parse(state.parameters);
				delete storeParameters[key];
				state.parameters = JSON.stringify(storeParameters);
			}
		},
		setPanel(state, value) {
			state.panel = value;
		},
		setSegment(state, value) {
			state.segment = value;
		},
		setPageName(state, value) {
			state.pageName = value;
		},
		setDateCompare(state, value) {
			state.datecompare = value;
		},
		setParameters(state, value) {
			state.parameters = JSON.stringify(value);
		},
		setAdmin(state, value) {
			state.admin = value;
		},
		/*setMastertagTop100(state, value) {
        	state.mastertagTop100 = value;
        },*/
		setUserId(state, value) {
			state.userId = value;
		},
		setExpiredFilters(state, value) {
			state.expiredFilters = value;
		},
	},
	actions: {
		addToParameters(context, payload) {
			context.commit("addToParameters", payload);
		},
		setParameters(context, value) {
			context.commit("setParameters", value);
		},
		removeFromParameters(context, key) {
			context.commit("removeFromParameters", key);
		},
		setPanel(context, value) {
			context.commit("setPanel", value);
		},
		setSegment(context, value) {
			context.commit("setSegment", value);
		},
		setDateCompare(context, value) {
			context.commit("setDateCompare", value);
		},
		setPageName(context, value) {
			context.commit("setPageName", value);
		},
		setAdmin(context, value) {
			context.commit("setAdmin", value);
		},
		/*setMastertagTop100(context, value) {
        	context.commit("setMastertagTop100", value);
        },*/
		setUserId(context, value) {
			context.commit("setUserId", value);
		},
		setExpiredFilters(context, value) {
			context.commit("setExpiredFilters", value);
		},
		resetDefault(context) {
			//Object.keys(this.state).forEach((key) => console.log(key))
			Object.keys(this.state).forEach((key) => delete this.state[key]);
			context.commit("setParameters", "");
			context.commit("setPanel", "");
			context.commit("setSegment", "");
			context.commit("setDateCompare", { gte: "", lte: "" });
			context.commit("setPageName", "");
			context.commit("setAdmin", 1);
			context.commit("setUserId", 0);
			context.commit("setExpiredFilters", "");
			//context.commit("setMastertagTop100", "");
		},
	},
});
